import { TELEGRAM_OPEN_URL } from '@/constants';

interface TelegramNotificationUrlParams {
  address?: string | null;
  network?: string | null;
  isEnabled?: boolean;
}

// Canonical names accepted by the notifications service. Do not turn unsupported
// Bitcoin deployments into another network's subscription.
export function getTelegramNetwork(network?: string | null): string | undefined {
  switch (network) {
    case 'mutiny':
    case 'mutinynet':
      return 'mutinynet';
    case 'main':
    case 'mainnet':
      return 'mainnet';
    case 'alpha-mainnet':
    case 'mainnet-alpha':
      return 'mainnet-alpha';
    case 'testnet':
    case 'signet':
      return network;
    default:
      return undefined;
  }
}

export const getTelegramNotificationUrl = ({ address, network, isEnabled = false }: TelegramNotificationUrlParams): string | undefined => {
  const serviceNetwork = getTelegramNetwork(network);
  if (network && !serviceNetwork) return undefined;
  if (isEnabled || !address || !serviceNetwork) return TELEGRAM_OPEN_URL;
  const payload = `_${address}_${serviceNetwork}`;
  return payload.length <= 64 ? `${TELEGRAM_OPEN_URL}?start=${payload}` : TELEGRAM_OPEN_URL;
};

// The bot accepts whitespace-delimited commands when a full address exceeds
// Telegram's 64-character deep-link payload limit.
export const getTelegramManualCommand = ({ address, network, isEnabled = false }: TelegramNotificationUrlParams): string | null => {
  const serviceNetwork = getTelegramNetwork(network);
  if (isEnabled || !address || !serviceNetwork || `_${address}_${serviceNetwork}`.length <= 64) return null;
  return `/start ${address} ${serviceNetwork}`;
};
